module.exports = __webpack_public_path__ + "static/media/TerrinaAberta.e3aac794.png";